import React, { useRef, useCallback } from "react";
import { Animated, Text, View, TouchableWithoutFeedback } from "react-native";
import { EStyleSheet, useDynamicStyles } from "react-native-extended-stylesheet-typescript";
import { MediaQueries } from "../../components/hooks/dynamicStyleHook";
import { GlobalStyles } from "../../components/style/Style";
import { useServices } from "../../contexts/ServiceContext";
import { useApplication } from "../../contexts/ApplicationContext";
import { AnimatedBackground } from "./AnimatedBackground";
import { AnimatedFree } from "./AnimatedFree";
import { ButtonSize, ButtonTheme, RoundedButton } from "../../components/buttons/roundedButton/RoundedButton";
import DefaultImage from "../../assets/splash_background.png";

export const Splash404 = (): JSX.Element => {
    const { edgeDeploy } = useServices();
    const { appState } = useApplication();
    const styles = useDynamicStyles(calculateStyles);
    const opacity = useRef(new Animated.Value(0)).current;

    Animated.timing(opacity, {
        toValue: 1,
        useNativeDriver: true,
        duration: 500,
    }).start();

    const onComplete = useCallback(() => {
        window.location.href = "https://edge.twinspires.com/casino/play-for-free/";
    }, []);

    return (
        <TouchableWithoutFeedback onPress={() => onComplete()}>
            <View style={[styles.container, edgeDeploy ? styles.edgeContainer : {}]}>
                <Animated.View style={[styles.animatedContainer, { opacity }]}>
                    <AnimatedFree direction={-1} complete={appState.splashTimerComplete}>
                        <Text style={[styles.header]}>Event</Text>
                    </AnimatedFree>
                    <AnimatedFree direction={1} complete={appState.splashTimerComplete}>
                        <Text style={styles.header}>Not Found</Text>
                    </AnimatedFree>
                    <View style={styles.playContainer}>
                        <RoundedButton
                            config={{
                                buttonText: "Play more FreePlay",
                                size: ButtonSize.LARGE,
                                theme: ButtonTheme.ACCENTED,
                            }}
                            onPress={() => onComplete()}
                        />
                    </View>
                </Animated.View>
                <AnimatedBackground
                    opacity={opacity}
                    imageUri={DefaultImage}
                    complete={appState.splashTimerComplete}
                ></AnimatedBackground>
            </View>
        </TouchableWithoutFeedback>
    );
};

const calculateStyles = () => {
    return EStyleSheet.create({
        [MediaQueries.SMALL]: {
            edgeContainer: {
                margin: 15,
            },
        },
        edgeContainer: {
            margin: 30,
            borderRadius: () => EStyleSheet.value(GlobalStyles.BORDER_RADIUS),
        },
        container: {
            alignItems: "center",
            alignSelf: "stretch",
            justifyContent: "center",
            display: "flex",
            flex: 1,
            overflow: "hidden",
            cursor: "pointer",
        },
        playContainer: {
            display: "flex",
            flexGrow: 0,
            width: 250,
            marginTop: 100,
            height: 70,
            position: "relative",
            zIndex: 2,
        },
        animatedContainer: {
            alignSelf: "stretch",
            position: "relative",
            alignItems: "center",
            zIndex: 1,
        },
        header: {
            fontFamily: () => EStyleSheet.value(GlobalStyles.HEADER_FONT),
            fontSize: 60,
            fontWeight: "bold",
            alignSelf: "stretch",
            textAlign: "center",
            lineHeight: 78,
            color: () => EStyleSheet.value(GlobalStyles.SPLASH_LOGO),
        },
    });
};
